
  <!--mat-carousel
      timings="250ms ease-in"
      [autoplay]="true"
      interval="3000"
      color="accent"
      maxWidth="auto"
      maintainAspectRatio="false"
      keepAspectRatio="false"
      proportion="45"
      slides="1px"
      slideHeight='80%'
      [loop]="true"
      [hideArrows]="false"
      [hideIndicators]="true"
      [useKeyboard]="true"
      [useMouseWheel]="true"
      orientation="100000tr"
  
    >
      <mat-carousel-slide  
        #matCarouselSlide
        *ngFor="let slide of slides; let i = index"
        [image]="slide.image"
        overlayColor="#FBEEE6"
        [hideOverlay]="true"
      ></mat-carousel-slide>
    </mat-carousel-->

    <div class="container">
      <div class="carousel">
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
        <div class="carousel__face"></div>
      </div>
    </div>


    